import { render } from "./HomeIcon.vue?vue&type=template&id=530410ac"
const script = {}
script.render = render

export default script